import styled from "styled-components";
import { COLORS } from "../../../values/colors";

export {
  HeroBanner,
  Eyebrow,
  HeroTitle,
  HeroText,
  ContentContainer,
  NoticeCard,
  NoticeTitle,
  NoticeText,
  UserCard as ReservationCard,
  UserHeader as ReservationHeader,
  UserTitle as ReservationTitle,
  UserSubline as ReservationSubline,
  RoleBadge as StatusBadge,
  FormGrid,
  Field,
  FieldLabel,
  Input,
  Select,
  ActionRow,
  Button,
  Message,
} from "../AdminUserManagement/styles";

export const ItemList = styled.div`
  display: grid;
  gap: 0.85rem;
`;

export const ItemCard = styled.div`
  padding: 1rem 1.1rem;
  border-radius: 1rem;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.08);
`;

export const ItemTitleRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  align-items: baseline;

  @media (max-width: 720px) {
    flex-direction: column;
  }
`;

export const ItemTitle = styled.h3`
  margin: 0;
  color: ${COLORS.white};
  font-size: 1rem;
`;

export const ItemMeta = styled.p`
  margin: 0.35rem 0 0;
  color: rgba(255, 255, 255, 0.68);
  line-height: 1.5;
`;
